// The university is a XOR - either a record from the nomenclature or free text, never both.
// The form disables the counterpart input, so only the "neither is filled" case can happen here.
export const validateInternshipStudent = values => {
  const errors = {};

  if (!values?.universityId && !values?.universityName?.trim()) {
    const message = "Изберете университет от списъка или въведете име на университет!";
    errors.universityId = message;
    errors.universityName = message;
  }

  return errors;
};

export const validateInternships = internships => {
  if (!internships?.length) return "Моля добавете поне един стаж!";

  const hasInvalidPeriod = internships.some(
    internship => internship?.startDate && internship?.endDate && internship.startDate > internship.endDate,
  );

  if (hasInvalidPeriod) return "Началната дата на стажа не може да е след крайната!";

  return undefined;
};

// The shared multipart builder serialises nested arrays as internships[0][name], while the
// backend model binder expects internships[0].name - flatten the array into dotted keys here.
const flattenInternships = (internships = []) =>
  internships.reduce((payload, internship, index) => {
    Object.entries(internship ?? {}).forEach(([field, value]) => {
      if (value === null || value === undefined || value === "") return;

      payload[`internships[${index}].${field}`] = value;
    });

    return payload;
  }, {});

export const buildInternshipStudentPayload = ({ internships, universityName, ...rest }) => ({
  ...rest,
  universityName: universityName?.trim() || null,
  ...flattenInternships(internships),
});

// Coordinator approval: every internship needs exactly one mentor and at least one location.
// The inputs already disable each other, so only the "none picked" case can reach here.
export const validateInternshipApprovals = approvals => {
  if (!approvals?.length) return "Няма стажове за одобрение!";

  const missingMentor = approvals.some(approval => !approval?.employeeId && !approval?.externalMentorName?.trim());

  if (missingMentor) return "Изберете ментор за всеки стаж - преподавател или външен!";

  const missingLocation = approvals.some(approval => !approval?.locations?.some(item => item?.location?.trim()));

  if (missingLocation) return "Добавете поне една локация за всеки стаж!";

  return undefined;
};
